import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import TrustAdminDashboard from '../components/dashboard/index.vue';
import TrustAdminMain from '../components/trust-admin-main/index.vue';
import { RouteN } from '../constants/router-name';
import KitchenSink from '@/shared/components/kitchensink/index.vue';
import TrustDataMain from '../components/trust-data-main/index.vue';
import AutoLogin from '../components/auto-login/index.vue';
import Logout from '../components/logout/index.vue';
import NoAccess from '../components/no-access/index.vue';
import TrustDataBanks from '../components/trust-data-banks/index.vue';
import TrustDataPractices from '../components/trust-data-practices/index.vue';
import TrustDataInvestigationTypes from '../components/trust-data-investigation-types/index.vue';
import store from '@/trust-admin-app/store';
import { AuthorizedUser } from '../models/authorized-user';
import { accessPermitted } from '@/shared/components/helpers';
import TimesheetApproval from '../components/timesheet-approval/index.vue';
import InvestigationsMain from '../components/investigations-main/index.vue';
import CalendarMain from '../components/calendar-main/index.vue';
import InvestigatorDashboard from '../components/investigator-dashboard/index.vue';
import InvestigatorMain from '../components/investigator-main/index.vue';
import InvestigatorInvestigations from '../components/investigator-investigations/index.vue';
import InvestigatorTimesheets from '../components/investigator-timesheets/index.vue';
import PracticeMain from '../components/practice-main/index.vue';
import PracticeDashboard from '../components/practice-dashboard/index.vue';
import PracticeInvestigationDetails from '../components/practice-investigation-details/index.vue';
import PracticeBank from '../components/practice-bank/index.vue';
import TrustDataTrustTeam from '../components/trust-data-trust-team/index.vue';
import PracticeAccountingDetails from '../components/practice-accounting-details/index.vue';
import PracticeNotes from '../components/practice-notes/index.vue';
import PracticeCorrespondence from '../components/practice-correspondence/index.vue';
import PracticePeople from '../components/practice-people/index.vue';
import Routines from '../components/routines/index.vue';
import FollowUp from '../components/follow-up/index.vue';
import PracticeLinkedPractices from '../components/practice-linked-practices/index.vue';
import TrustDataAccountingSoftware from '../components/trust-data-accounting-software/index.vue';
import TrustDataExternalExaminer from '../components/trust-data-external-examiner/index.vue';
import TrustDataExternalExaminerApproval from '../components/trust-data-external-examiner-approval/index.vue';
import TrustDataExternalExaminerSignUpApproval from '../components/trust-data-external-examiner-sign-up-approval/index.vue';
import TrustDataPageSettings from '../components/trust-data-pagesettings/index.vue';
import ExternalExaminerMain from '../components/external-examiner-main/index.vue';
import ExternalExaminerDashboard from '../components/external-examiner-dashboard/index.vue';
import PracticeTrustCompliance from '../components/practice-trust-compliance/index.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: RouteN.TA.LoginPage.p,
    name: RouteN.TA.LoginPage.n,
    component: AutoLogin,
  },
  {
    path: RouteN.TA.LogoutPage.p,
    name: RouteN.TA.LogoutPage.n,
    component: Logout,
  },
  {
    path: RouteN.NoAccess.p,
    name: RouteN.NoAccess.n,
    component: NoAccess,
  },
  {
    path: RouteN.KitchenSink.p,
    name: RouteN.KitchenSink.n,
    component: KitchenSink,
  },
  {
    path: RouteN.KitchenSink2.p,
    name: RouteN.KitchenSink2.n,
    component: KitchenSink,
  },
  {
    path: RouteN.KitchenSink3.p,
    name: RouteN.KitchenSink3.n,
    component: KitchenSink,
  },
  {
    path: RouteN.TA.Main.p,
    meta: {
      requiresAuth: true,
      rolesAllowed: RouteN.TA.Main.r
    },
    redirect: { name: RouteN.TA.Home.n },
    name: RouteN.TA.Main.n,
    component: TrustAdminMain,
    children: [
      {
        path: RouteN.TA.Home.p,
        name: RouteN.TA.Home.n,
        component: TrustAdminDashboard
      },
      {
        path: RouteN.TA.Investigations.p,
        name: RouteN.TA.Investigations.n,
        meta: {
          rolesAllowed: RouteN.TA.Investigations.r
        },
        component: InvestigationsMain
      },
      {
        path: RouteN.TA.Routines.p,
        name: RouteN.TA.Routines.n,
        meta: {
          rolesAllowed: RouteN.TA.Routines.r
        },
        component: Routines
      },
      {
        path: RouteN.TA.FollowUp.p,
        name: RouteN.TA.FollowUp.n,
        meta: {
          rolesAllowed: RouteN.TA.FollowUp.r
        },
        component: FollowUp
      },
      {
        path: RouteN.TA.TimesheetApproval.p,
        name: RouteN.TA.TimesheetApproval.n,
        meta: {
          rolesAllowed: RouteN.TA.TimesheetApproval.r
        },
        component: TimesheetApproval
      },
      {
        path: RouteN.TA.Investigator.p,
        name: RouteN.TA.Investigator.n,
        meta: {
          rolesAllowed: RouteN.TA.Investigator.r
        },
        redirect: { name: RouteN.TA.InvestigatorDashboard.n },
        component: InvestigatorMain,
        children: [
          {
            path: RouteN.TA.InvestigatorDashboard.p,
            name: RouteN.TA.InvestigatorDashboard.n,
            meta: {
              rolesAllowed: RouteN.TA.InvestigatorDashboard.r
            },
            component: InvestigatorDashboard
          },
          {
            path: RouteN.TA.InvestigatorInvestigations.p,
            name: RouteN.TA.InvestigatorInvestigations.n,
            meta: {
              rolesAllowed: RouteN.TA.InvestigatorInvestigations.r
            },
            component: InvestigatorInvestigations
          },
          {
            path: RouteN.TA.InvestigatorCalendar.p,
            name: RouteN.TA.InvestigatorCalendar.n,
            meta: {
              rolesAllowed: RouteN.TA.InvestigatorCalendar.r
            },
            component: CalendarMain
          },
          {
            path: RouteN.TA.InvestigatorTimesheets.p,
            name: RouteN.TA.InvestigatorTimesheets.n,
            meta: {
              rolesAllowed: RouteN.TA.InvestigatorTimesheets.r
            },
            component: InvestigatorTimesheets
          },
        ]
      },
      {
        path: RouteN.TA.Practice.p,
        name: RouteN.TA.Practice.n,
        meta: {
          rolesAllowed: RouteN.TA.InvestigatorTimesheets.r
        },
        redirect: { name: RouteN.TA.PracticeDashboard.n },
        component: PracticeMain,
        children: [
          {
            path: RouteN.TA.PracticeDashboard.p,
            name: RouteN.TA.PracticeDashboard.n,
            meta: {
              rolesAllowed: RouteN.TA.PracticeDashboard.r
            },
            component: PracticeDashboard
          },
          {
            path: RouteN.TA.PracticeInvestigationDetails.p,
            name: RouteN.TA.PracticeInvestigationDetails.n,
            meta: {
              rolesAllowed: RouteN.TA.PracticeInvestigationDetails.r
            },
            component: PracticeInvestigationDetails
          },
          {
            path: RouteN.TA.PracticeBank.p,
            name: RouteN.TA.PracticeBank.n,
            meta: {
              rolesAllowed: RouteN.TA.PracticeBank.r
            },
            component: PracticeBank
          },
          {
            path: RouteN.TA.PracticeAccountingDetails.p,
            name: RouteN.TA.PracticeAccountingDetails.n,
            meta: {
              rolesAllowed: RouteN.TA.PracticeAccountingDetails.r
            },
            component: PracticeAccountingDetails
          },
          {
            path: RouteN.TA.PracticeNotes.p,
            name: RouteN.TA.PracticeNotes.n,
            meta: {
              rolesAllowed: RouteN.TA.PracticeNotes.r
            },
            component: PracticeNotes
          },
          {
            path: RouteN.TA.PracticePeople.p,
            name: RouteN.TA.PracticePeople.n,
            meta: {
              rolesAllowed: RouteN.TA.PracticePeople.r
            },
            component: PracticePeople
          },
          {
            path: RouteN.TA.PracticeCorrespondence.p,
            name: RouteN.TA.PracticeCorrespondence.n,
            meta: {
              rolesAllowed: RouteN.TA.PracticeCorrespondence.r
            },
            component: PracticeCorrespondence
          },
          {
            path: RouteN.TA.PracticeLinkedPractice.p,
            name: RouteN.TA.PracticeLinkedPractice.n,
            meta: {
              rolesAllowed: RouteN.TA.PracticeLinkedPractice.r
            },
            component: PracticeLinkedPractices
          },
          {
            path: RouteN.TA.PracticeTrustCompliance.p,
            name: RouteN.TA.PracticeTrustCompliance.n,
            meta: {
              rolesAllowed: RouteN.TA.PracticeTrustCompliance.r
            },
            component: PracticeTrustCompliance
          },
        ]
      },
      {
        path: RouteN.TA.ExternalExaminer.p,
        name: RouteN.TA.ExternalExaminer.n,
        meta: {
          rolesAllowed: RouteN.TA.ExternalExaminer.r
        },
        redirect: { name: RouteN.TA.ExternalExaminerDashboard.n },
        component: ExternalExaminerMain,
        children: [
          {
            path: RouteN.TA.ExternalExaminerDashboard.p,
            name: RouteN.TA.ExternalExaminerDashboard.n,
            meta: {
              rolesAllowed: RouteN.TA.ExternalExaminerDashboard.r
            },
            component: ExternalExaminerDashboard
          },
        ]
      },
      {
        path: RouteN.TA.TrustData.p,
        name: RouteN.TA.TrustData.n,
        redirect: { name: RouteN.TA.TrustDataPractices.n },
        component: TrustDataMain,
        children: [
          {
            path: RouteN.TA.TrustDataPractices.p,
            name: RouteN.TA.TrustDataPractices.n,
            component: TrustDataPractices
          },
          {
            path: RouteN.TA.TrustDataAccountingSoftware.p,
            name: RouteN.TA.TrustDataAccountingSoftware.n,
            meta: {
              rolesAllowed: RouteN.TA.TrustDataAccountingSoftware.r
            },
            component: TrustDataAccountingSoftware
          },
          {
            path: RouteN.TA.TrustDataInvestigationType.p,
            name: RouteN.TA.TrustDataInvestigationType.n,
            meta: {
              rolesAllowed: RouteN.TA.TrustDataInvestigationType.r
            },
            component: TrustDataInvestigationTypes,
          },
          {
            path: RouteN.TA.TrustDataBanks.p,
            name: RouteN.TA.TrustDataBanks.n,
            meta: {
              rolesAllowed: RouteN.TA.TrustDataBanks.r
            },
            component: TrustDataBanks,
          },
          {
            path: RouteN.TA.TrustDataTrustTeam.p,
            name: RouteN.TA.TrustDataTrustTeam.n,
            meta: {
              rolesAllowed: RouteN.TA.TrustDataTrustTeam.r
            },
            component: TrustDataTrustTeam,
          },
          {
            path: RouteN.TA.TrustDataExternalExaminer.p,
            name: RouteN.TA.TrustDataExternalExaminer.n,
            meta: {
              rolesAllowed: RouteN.TA.TrustDataExternalExaminer.r
            },
            component: TrustDataExternalExaminer,
          },
          {
            path: RouteN.TA.TrustDataExternalExaminerApproval.p,
            name: RouteN.TA.TrustDataExternalExaminerApproval.n,
            meta: {
              rolesAllowed: RouteN.TA.TrustDataExternalExaminerApproval.r
            },
            component: TrustDataExternalExaminerApproval,
          },
          {
            path: RouteN.TA.TrustDataExternalExaminerSignUpApproval.p,
            name: RouteN.TA.TrustDataExternalExaminerSignUpApproval.n,
            meta: {
              rolesAllowed: RouteN.TA.TrustDataExternalExaminerSignUpApproval.r
            },
            component: TrustDataExternalExaminerSignUpApproval,
          },
          {
            path: RouteN.TA.TrustDataPageSettings.p,
            name: RouteN.TA.TrustDataPageSettings.n,
            meta: {
              rolesAllowed: RouteN.TA.TrustDataPageSettings.r
            },
            component: TrustDataPageSettings,
          },
        ]
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to) => {
  const authUser: AuthorizedUser = store.getters.getUserAccount;
  if (to.matched.length >= 2 && !accessPermitted(
    authUser.user.roles, to.meta.rolesAllowed as any[])) {
    router.replace({ name: RouteN.NoAccess.n });
  }
});


export default router